// extracted by mini-css-extract-plugin
module.exports = {"root":"SLAttiZX","swatch":"H0Ul4o_O","selected":"Vma0CTFO","check":"fmnMcB3U"};